import Product, {IProduct} from "./Product"

interface IProps {
    product: IProduct
}

const SingleProduct = ({product}: IProps) => {
    return <Product product={product} single={true} />
}

export default SingleProduct
